import DepositsService from './deposits';
import WithdrawalsService from './withdraws';

class TransfersService {
  deposits = new DepositsService();
  withdrawals = new WithdrawalsService();
}

export default TransfersService;
